var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-card',{staticClass:"cardStyle"},[_c('b-card-title',{staticClass:"cardTitle"},[_vm._v("\n      "+_vm._s(_vm.topic.title)+"\n    ")]),_vm._v(" "),_c('hr',{staticClass:"solid my-4"}),_vm._v(" "),_c('p',{staticClass:"cardContent"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.topic.body)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }